import { persistentKVStore } from '../persistence';
import { RouterBridge } from '../routing';
var handleUnauthorizedError = function (info) {
    if (info.error.status === 401) {
        var isTokenPresent = !!persistentKVStore.getItem('token') || !!persistentKVStore.getItem('adminToken');
        if (!isTokenPresent) {
            return;
        }
        RouterBridge.push('/sign-out');
    }
};
export var initAuthInterceptor = function () {
    window.addEventListener('squire-http-request-error', function (event) {
        handleUnauthorizedError(event.detail);
    });
};
